import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
export const useAction = (action, ...args)=>{
    const dispatch = useDispatch();
    return useCallback((...cbArgs)=>dispatch(action(...args, ...cbArgs)), [
        dispatch,
        action,
        ...args
    ]);
};
